import { apiServer } from '../settings';
import { getToken } from './token';
// import createLog from '../utils/create-log';

const addNote = (userGuid, userAuthorization, game, guid, text, done) => {
    // if (!userGuid) return done('missing userGuid')
    // if (!userAuthorization) return done('missing userAuthorization')
    if (!game) return done('missing game');
    if (!guid) return done('missing guid');
    // if (!text) return done('missing text');

    const headers = new Headers({
        Authorization: 'Bearer ' + getToken(),
        'Content-Type': 'application/json',
    });

    const options = {
        method: 'POST',
        headers,
        mode: 'cors',
        cache: 'default',
        body: JSON.stringify({ text }),
    };

    const url = `${apiServer}/user-add-note?game=${game}&guid=${guid}`;

    fetch(url, options)
        .then(response => {
            return response.json();
        })
        .then(response => {
            if (response.success === false) return done(response.err);
            if (response.success === true) return done();
            if (!response.success) return done('response without success true|false');
        })
        .catch(error => {
            console.error('Error:', error);
            done(error.message);
        });
};

export default addNote; 